import React, { useState, useEffect } from "react";
import { useMatStyles, Wrapper } from "./style";
import { Grid as MatGrid, Paper } from "@mui/material";
import { Input } from "antd";
import { FilterList } from "@mui/icons-material";
import { customBaseUrl, httpGet } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import { DeleteFilled, SearchOutlined } from "@ant-design/icons";
import AntTable from "../../components/CustomTable/AntTable";

const FeedbackComponent = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const styles = useMatStyles();
  const [loading, setLoading] = useState(false);
  const [totalFeedBack, setTotalFeed] = useState(0);
  const [search, setSearch] = useState({
    searchBy: "partTranType",
    searchText: "",
  });

  const columns = [
    { title: "Feedback", dataIndex: "answer", width: '5%' },
    { title: "Are you presently using wayabank", dataIndex: "active", render: () => <span>yes</span>, width: '3%' },
    { title: "Date", dataIndex: "createdAt", sorter: true, width: '3%' },
    { title: " ", dataIndex: "active", render: () => <DeleteFilled />, width: '10%' },
  ];

  const getFeedbacks = async (page, size) => {
    setFeedbacks([]);
    showLoader();
    setLoading(true);
    const response = await httpGet(
      `${customBaseUrl.contentManagementUrl}/api/v1/admin/feedback/user-feedback-list`
    );
    if (response.status === true) {
      hideLoader();
      setFeedbacks(response.data);
      setTotalFeed(response.data.length);
      setLoading(false);
    } else {
      hideLoader();
      setLoading(false);
    }
  };

  useEffect(() => {
    getFeedbacks();
  }, []);

  const handleShowFilter = () => {
    setSearch({ ...search, searchText: '' });
  };

  return (
    <>
      <Wrapper>
        <MatGrid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={styles.matGrid}
        >
          <Paper elevation={1} className={styles.card}>
            <div className={styles.dibot}>
              <span style={{ float: "left" }} className={styles.diTop}>
                Total No. of Feedback
              </span>
            </div>
            <br />
            <div style={{ justifyContent: 'left', marginTop: 50 }}>
              <span className={styles.money}>{totalFeedBack}</span>
            </div>
          </Paper>
        </MatGrid>

        <div style={tool} className="col-md-5">
          <div className={styles.searchRow}>
            <Input
              className={styles.searchInput}
              placeholder="Search Feedbacks"
              value={search.searchText}
              onChange={(event) => setSearch({ ...search, searchText: event.target.value })}
              prefix={<SearchOutlined className={styles.searchIcon} />}
            />
          </div>
          <div className={styles.searchRow}>
            <FilterList onClick={handleShowFilter} />
            Filter
          </div>
        </div>

        <MatGrid
          container
          direction="row"
          alignItems="center"
          className={styles.matGrid}
        >
          <div style={{ height: 800 }}>
            <AntTable
              pagination={null}
              users={search.searchText
                ? feedbacks.filter(req => req?.answer.toLowerCase()?.includes(search?.searchText.toLowerCase()))
                : feedbacks}
              loading={loading}
              columns={columns}
            />
          </div>
        </MatGrid>
      </Wrapper>
    </>
  );
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export default FeedbackComponent;
